
<SupplierDetailCard class="summary" :title="title" :description="description">
    <template #content>
        <template v-for="(n, i) in data">
            <div class="row data-row no-gutters" :key="i" v-if="n.isVisible === undefined || n.isVisible(n)">
                <div class="col col-6 text-left">
                    <slot :name="'label(' + i + ')'" v-bind="n">{{ n.label }}</slot>
                </div>
                <div class="col col-6 text-right numeric">
                    <slot :name="'value(' + i + ')'" v-bind="n">{{ n.value }}</slot>
                </div>
            </div>
        </template>
    </template>
</SupplierDetailCard>
